export function getDashboardReplayRedirect(pathname, search = "") {
    if (pathname !== "/dashboard") return null;
    const params = new URLSearchParams(search || "");
    const sessionKey = params.get("session_key");
    if (!sessionKey || !sessionKey.trim()) return null;
    const query = params.toString();
    return `/replay${query ? `?${query}` : ""}`;
}
